const CSharp = () => {
  return <h1>CSharp  </h1>;
};

export default CSharp;